<template>
  <svg class="text-success" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <path d="M22,15a7,7,0,1,1-7-7A7,7,0,0,1,22,15Zm-7.81,3.706,5.194-5.194a.452.452,0,0,0,0-.639l-.639-.639a.452.452,0,0,0-.639,0l-4.236,4.236-1.977-1.977a.452.452,0,0,0-.639,0l-.639.639a.452.452,0,0,0,0,.639l2.935,2.935a.452.452,0,0,0,.639,0Z" transform="translate(-8 -8)" class="fill-current"/>
  </svg>
</template>
